import { getStorageData, setStorageData } from "@/utils/storage";
import {
  deleteCompany as apiDeleteCompany,
  getCompanyById as apiGetCompanyById,
  updateCompany as apiUpdateCompany
} from "@api/company";
import { default as apiGetRoles } from "@api/role";
import { default as apiGetRpes } from "@api/rpe";
import { default as apiGetTiers } from "@api/tier";
import { extractIds } from "./helper";

const STORAGE_COMPANY_KEY = "company";

const companyStore = {
  namespaced: true,
  state: {
    company: {
      ...getStorageData(STORAGE_COMPANY_KEY),
      isLoading: false,
      tier: {}
    },
    roles: [],
    rpes: [],
    tiers: []
  },
  getters: {
    currentCompany(state) {
      return state.company;
    },
    roles(state) {
      return state.roles;
    },
    rpes(state) {
      return state.rpes;
    },
    tiers(state) {
      return state.tiers;
    },
    isLoading(state) {
      return state.company.isLoading;
    }
  },
  mutations: {
    setCompany(state, payload) {
      state.company = {
        ...state.company,
        ...payload
      };

      setStorageData(STORAGE_COMPANY_KEY, state.company);
    },
    // TODO: extract it to specific store
    setRoles(state, payload) {
      state.roles = payload;
    },
    setTiers(state, payload) {
      state.tiers = payload;
    },
    // TODO: extract it to specific store
    setRpes(state, payload) {
      state.rpes = payload;
    },
    setLoading(state, payload) {
      state.company.isLoading = payload;
    }
  },
  actions: {
    async getCompanyById({ commit }, id) {
      const { data: currentCompanyData } = await apiGetCompanyById(id);

      commit("setCompany", currentCompanyData);
      return currentCompanyData;
    },
    async getTiers({ commit }) {
      commit("setLoading", true);

      try {
        const { data: tiers } = await apiGetTiers();
        commit("setTiers", tiers);
      } catch (error) {
        // TODO: use logger here
        console.error(error);
      } finally {
        return commit("setLoading", false);
      }
    },
    async getRoles({ commit }) {
      commit("setLoading", true);

      try {
        const { data: roles } = await apiGetRoles();

        commit("setRoles", roles);
      } catch (error) {
        // TODO: use logger here
        console.error(error);
      } finally {
        return commit("setLoading", false);
      }
    },
    async getRpes({ commit }) {
      commit("setLoading", true);

      try {
        const { data: rpes } = await apiGetRpes();
        commit("setRpes", rpes);
      } catch (error) {
        // TODO: use logger here
        console.error(error);
      } finally {
        return commit("setLoading", false);
      }
    },
    async updateCompany({ commit, state }, payload) {
      commit("setLoading", true);
      const { id } = state.company;
      const { name, salesForce, tier, roles, rpes } = payload;

      const companyToUpdate = {
        id,
        name,
        salesForce,
        tier: tier.id,
        roles: extractIds(roles),
        rpes: extractIds(rpes)
      };

      const data = await apiUpdateCompany(companyToUpdate);

      commit("setCompany", data.companyUpdated);
    },
    async deleteCurrentCompany({ commit, state }, { onSuccess }) {
      commit("setLoading", true);

      try {
        await apiDeleteCompany(state.company.id);

        onSuccess();
      } catch (error) {
        // TODO: use logger here
        console.error(error);
      } finally {
        return commit("setLoading", false);
      }
    }
  }
};

export default companyStore;
